<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Reply</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full">
                        <div class="reply-body" v-if="reply">
                            {{ reply.reply_content }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="right text-right">
                        <button class="btn-primary" type="button" @click="releaseResponse" v-if="responseHasBeenFiltered">Release</button>
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReplyView',
        data() {
            return {
                reply: null
            }
        },
        mounted() {
            this.setMetaTitle('Media Request Reply | JournoLink Control')
            this.loadData()
        },
        methods: {
            loadData() {
                axios.get(route('mediarequests.replies.show', {mediaRequest: this.$route.params.mediaRequestId, reply: this.$route.params.reply}))
                    .then((response) => {
                        this.reply = response.data
                    })
            },
            /**
             * Release the response to the author
             *
             * @return {void}
             */
            releaseResponse() {
                axios.post(route('mediarequests.release', { mediaRequest: this.reply.reply_request, mediaRequestResponse: this.reply.reply_id }))
                    .then(response => {
                        this.$bus.$emit('alert.success', 'Response has been released to the author')
                        this.$emit('released')
                        this.closeView()
                    })
            },
            /**
             * Emit the close event to the parent
             *
             * @return {void}
             */
            closeView () {
                this.setMetaTitle('List Media Requests Replies | JournoLink Control')
                this.$router.go(-1)
            },
        },
        computed: {
            /**
             * Determine if the response has been filtered out
             *
             * @return {Boolean}
             */
            responseHasBeenFiltered() {
                if (!this.reply) {
                    return false;
                }

                return this.reply.reply_filtered || this.reply.reply_noreg || this.reply.reply_nosub
            },
        }
    }
</script>

<style lang="less">
</style>
